'use strict';

export function UserInviteDomainProvider() {
  return {
    $get: [
      '$injector',
      'AuthService',
      'AbstractDomainClass',
      'OrgMixin',
      'FirebaseQueueService',
      'ROOT_API_COLLECTION',
      'ROOT_API_SPEC',
      function ($injector, AuthService, AbstractDomainClass, OrgMixin, FirebaseQueueService,
                ROOT_API_COLLECTION, ROOT_API_SPEC) {

        function UserInviteDomain(data) {
          AbstractDomainClass.call(this, UserInviteDomain, data);
        }

        AbstractDomainClass.__inheritFrom(UserInviteDomain, 'UserInviteDomain', 'user-invites');

        UserInviteDomain.$constraints.addConstraints({
          user: {type: 'DomainLink', domainClass: 'UserDomain', links: 'invites', belongsTo: true},
          organization: {type: 'DomainLink', domainClass: 'OrganizationDomain', links: 'invites', belongsTo: true},
          inviter: {type: 'DomainLink', domainClass: 'PersonDomain'},
          status: {type: 'string', inList: ['rejected', 'cancelled', 'pending', 'accepted']},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        OrgMixin(UserInviteDomain);

        UserInviteDomain.prototype.accept = function accept() {
          return __updateStatus.call(this, 'accepted');
        };

        UserInviteDomain.prototype.reject = function reject() {
          return __updateStatus.call(this, 'rejected');
        };

        function __updateStatus(status) {
          var request = {
            method: 'organizations/invites/response',
            inviteId: this.$id,
            status: status
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        }

        return UserInviteDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/organizations/domain/UserInviteDomain.js